// import React from "react";
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import '../../css/Result.css';

export default class Result extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ifService: [],
      ifLetter: [],
      isLoaded:false,
    }
  }

  static defaultProps = {
    datas: {},
    ifService: [],
    ifLetter: [],
    isResult: null
  };


  async componentWillMount() {
    // console.log('im here in Result');
  }

  getHTML = (text) => {
    var nText = text.substring(0,300);
    nText += "<p>...<p>";
    var str =  {__html: nText};
    return str;
  }

  _Drlist = (data) => {
    var str = "";
    for (const [key, value] of Object.entries(data)){
      str += value.nom_affichage+", ";
    }
    return str.substring(0, str.length-2);
  }

  _list = (obj) => {
    var  returnValue = [];
    var tab = [];

    for(var c= 0; c < obj.length; c++){
      for (const [key, value] of Object.entries(obj[c].services)){
        if(!tab.includes(value)){
          tab.push(value);
        }
      }
    }

    if (this.props.ifLetter && this.props.ifLetter.length >=1) {
      tab = [];
      for (var i= 0; i < obj.length; i++) {
        for (const [key, value] of Object.entries(this.props.ifLetter)) {
          if (this.props.ifLetter.includes(obj[i].lettre)) {
            if (this.props.ifService && this.props.ifService.length >=1) {
              for (const [key, value] of Object.entries(obj[i].services)) {
                if(this.props.ifService.includes(value.nom)){
                  if(!tab.includes(value)){
                    tab.push(value);
                  }
                }
              }
            } else {
              for (const [key, value] of Object.entries(obj[i].services)){
                  if(!tab.includes(value)){
                    tab.push(value);
                  }
              }
            }
          }
        }
      }
    }
// <div dangerouslySetInnerHTML={this.getHTML(value.texte_html)} />
    for (const [key, value] of Object.entries(tab)){
      returnValue.push(
        <div key={key+i} className="card">
        <Link to={{
          pathname:'/annuaire/service:datas',
          datas: value 
        }}>
          <header className="card-header">
            <p className="card-header-title">
              {value.nom}
            </p>
          </header>

          </Link>
        </div>
      )
    }
    return returnValue;
  }

  render() {
    // console.log('Result this.state : ',this.state);
    // console.log('Result this.props : ',this.props);
    return (
      <div className="resultContainer">
        {this.props.isResult ? (
          this._list(this.props.datas)
        ) : (
          <div className="App">
            <p>Pas de resultats</p>
          </div>
        )}
      </div>
    );
  }
}
